var _defs, _g, _g2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZrestartuj(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.76 109.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3.48px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.63,
    y1: 1.74,
    x2: 17.62,
    y2: 21.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.14,
    y1: 24.27,
    x2: 17.62,
    y2: 21.27
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61.46,
    y1: 107.59,
    x2: 66.55,
    y2: 88.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.99,
    y1: 83.12,
    x2: 66.08,
    y2: 88.21
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.77,66.26c1.46-4.24,2.26-8.79,2.26-13.52,0-23-18.65-41.65-41.65-41.65-9.64,0-17.49,2.22-24.55,7.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.88,44.08c-.74,3.1-1.14,6.33-1.14,9.65,0,23,18.65,41.65,41.65,41.65,7.73,0,14.96-2.11,21.17-5.78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZrestartuj);
export default __webpack_public_path__ + "static/media/zrestartuj.57ed6d4ccc9316a337949b5ef2c571b1.svg";
export { ForwardRef as ReactComponent };